import { render, staticRenderFns } from "./SalesCouponSummary.vue?vue&type=template&id=fed0bfd4&"
import script from "./SalesCouponSummary.vue?vue&type=script&lang=js&"
export * from "./SalesCouponSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports